import React from "react";
import { Link } from "react-router-dom";
import "./styles/Footer.css";
import { scrollToTop } from "./util";

const Footer: React.FC = () => {
    return (
        <>
            <div
                style={{
                    position: "relative",
                    height: "0px",
                    marginBottom: "2px",
                }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1000 100"
                    preserveAspectRatio="none"
                    shapeRendering="geometricPrecision"
                    style={{
                        display: "block",
                        width: "100%",
                        backfaceVisibility: "hidden",
                        WebkitBackfaceVisibility: "hidden",
                        transform: "translateZ(0)",
                        WebkitTransform: "translateZ(0)",
                    }}
                >
                    <path
                        d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7
       c75.8,32.2,133.7,44.5,192.6,49.7c23.6,2.1,48.7,3.5,103.4-2.5
       c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5
       c39.2-0.7,92.8-6.7,134-22.4c21.2-8.1,52.2-18.2,79.7-24.2
       C399.3,7.9,411.6,7.5,421.9,6.5z"
                        fill="#f9f9f9"
                        stroke="transparent"
                        strokeWidth="0"
                        shapeRendering="geometricPrecision"
                    />
                </svg>
            </div>
            <footer className="footer">
                <div className="footer-container">
                    {/* Logo and Description */}
                    <div className="footer-section">
                        <h2>Disclaimer</h2>
                        <p className="footer-description">
                            This site is neither endorsed nor approved by
                            Alcoholics Anonymous World Services, Inc. It is
                            solely provided by the 5th Tradition Group as part
                            of its Twelfth Step work in reaching out to the
                            alcoholic who still suffers. Although some of the
                            items contained in these pages were published by AA
                            World Services, this does not imply approval by the
                            General Service Conference. This site provides links
                            to a few recovery-oriented websites. Inclusion of
                            these links is intended to be a convenience for
                            those who visit our site, but such inclusion does
                            not constitute any endorsement or approval of, or
                            affiliation with either the Atlanta Central Office
                            or Alcoholics Anonymous World Services, Inc.
                        </p>
                    </div>

                    {/* Navigation Links */}
                    <div className="footer-links">
                        <h3>Navigation</h3>
                        <ul>
                            <li>
                                <Link to="/" onClick={scrollToTop}>
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link to="/about" onClick={scrollToTop}>
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link to="/events">Events</Link>
                            </li>
                            <li>
                                <Link to="/speakers" onClick={scrollToTop}>
                                    Recent Speakers
                                </Link>
                            </li>
                            <li>
                                <Link to="/workshop" onClick={scrollToTop}>
                                    Workshop Speakers
                                </Link>
                            </li>
                            <li>
                                <Link to="/archived" onClick={scrollToTop}>
                                    Archived Speakers
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" onClick={scrollToTop}>
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>© 2025 5TG. All rights reserved.</p>
                </div>
            </footer>
        </>
    );
};

export default Footer;
